import { FlagNameType, FlagRecordType } from "../types";

function isFlagActiveForClass(
  flags: Partial<FlagRecordType>,
  flagName: FlagNameType,
  classId: string,
): boolean {
  const flagValue = flags?.[flagName] || [];
  if (flagValue.length === 0) {
    return false;
  }
  if (flagValue.includes("all")) {
    return true;
  }
  return flagValue.includes(classId);
}

export { isFlagActiveForClass };
